export default name =>
  (name.charAt(0).toUpperCase() + name.slice(1)).replace(/_/g, ' ')



// WEBPACK FOOTER //
// ./src/utils/displayName.js